<template>
  <footer class="footer" id="applicationFooter">
    <div class="container-fluid">
    </div>
    <div class="container-fluid" style="margin-bottom: 0">
        <div class="col-md-12 bootomFooter">
          <div v-if="brand.toLowerCase() == 'cargill'">&copy; {{user_lang.copyrights}}&nbsp;&nbsp;<a v-bind:href="user_lang.privacypolicy_link" target="_blank">
		  {{user_lang.privacypolicy}}</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a v-bind:href="user_lang.termsandconditions_link" target="_blank">
		  {{user_lang.termsandconditions}}</a></div>
          <div v-if="brand.toLowerCase() !== 'cargill'">&copy; {{brand}}, Incorporated. All Rights Reserved.&nbsp;&nbsp;</div>
        </div>
    </div>
  </footer>
</template>
<script>
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import storage from '@/helpers/storage'
  export default {
    name: 'applicationFooter',
    created () {
      var self = this
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
      })
    },
    data () {
      return {
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        user_lang: {},
        brand: storage.get('brand')
      }
    },
    methods: {
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      }
    }
  }
</script>
<style scoped>
/*color: #d9d1cf; font-family: HelveticaNeueW01-75Bold, Helvetica, Arial, sans-serif; font-size: 12px*/
  a.bootomFooter:hover {
    color: var(--theme-primary);
 color: #273238 !important
  }
  .bootomFooter a, .bootomFooter a:active  {
    color: var(--theme-primary);
 color: #273238 !important
  }
  .bootomFooter a:hover {
    text-decoration: underline;
    color:#fff;
  }
  #applicationFooter{
    bottom: 0;
 padding: 13px 13px 13px 200px;
 height: initial;
 background: #fff;
 color: #273238 !important;
  }
  @media (max-width: 767px) {
  #applicationFooter{
 padding-left: 15px;
  }
  }
</style>



// WEBPACK FOOTER //
// footer.vue?e7719772